import { Outlet } from 'react-router-dom'

const DynamicsLayout = () => (
  <div className="w-full h-full">
    <Outlet />
  </div>
)

export default DynamicsLayout
